/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ShowManagementListShowResponse } from './ShowManagementListShowResponse';

export type ShowManagementListShowResponseApiRespoonse = {
    data?: ShowManagementListShowResponse;
    status?: ShowManagementListShowResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ShowManagementListShowResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

